
// export const PROCESS_NEW_FILE = 'process new file';
export const DOC_CATEGORY_ERROR = 'Doc error';
export const ADD_UNCATEGORIZED_FILE = 'ADD_UNCATEGORIZED_FILE';
export const GET_DOC_TREE = "GET_DOC_CATEGORY"
export const ADD_UNCATEGORIZED_FILE_ERROR = 'File error'
export const ADD_UNCATEGORIZED_FILE_SUCCESS = 'ADD_UNCATEGORIZED_FILE_SUCCESS';
export const SUBMIT_CREATE_CATEGORY = 'CREATE_CATEGORY';
export const SET_DOC_TREE = 'Display Tree';
export const SET_CATMO_CATEGORIES = 'Catmo Tree';
export const CREATE_CATEGORY_SUCCESS = 'Succesfully craeted category';
export const CREATE_CATEGORY_ERROR = 'Error craeting category';
export const SUBMIT_FILE_REQUEST = 'submitted sara file';
export const CREATE_FILE_SUCCESS = 'succesfully created file';
export const CREATE_FILE_ERROR = 'error creating file';
export const FETCH_FILE_REQUEST = 'fetching category file';
export const FETCH_FILE_SUCCESS ='fetched file successfully';
export const SET_FILE_DATA = 'set file';
export const SUBMIT_EDIT_CATEGORY = 'submitted a category edit';
export const  EDIT_CATEGORY_SUCCESS = 'edit category successful';
export const EDIT_CATEGORY_ERROR = 'Error editing category';
export const DELETE_CATEGORY_REQUEST = 'Delete Category request';
export const DELETE_CATMO_CATEGORY = 'Delete Catmo Category';
export const DELETE_FILE_REQUEST = 'Delete file request';
export const DELETE_CATEGORY_SUCCESS = 'Delete category successfully';
export const DELETE_CATEGORY_ERROR = 'Delete category error';
export const DELETE_FILE_SUCCESS = 'Delete File successfully';
export const DELETE_FILE_ERROR = 'Delete file error';
export const SUBMIT_EDIT_FILE = 'submit a file edit';
export const EDIT_FILE_SUCCESS = 'edit file successful';
export const EDIT_FILE_ERROR = 'Error editing file';
export const SET_SARA_NODE_ID = 'SET_SARA_NODE_ID';
export const SET_CATMO_NODE_ID = 'SET_CATMO_NODE_ID';
export const ASSIGN_FILE_TO_CATEGORY = 'ASSIGN_FILE_TO_CATEGORY';
export const ASSIGN_FILE_TO_CATEGORY_SUCCESS = 'ASSIGN_FILE_TO_CATEGORY_SUCCESS';
export const ASSIGN_FILE_TO_CATEGORY_ERROR = 'ASSIGN_FILE_TO_CATEGORY_ERROR';


// export const setDocCategory = (categoriesFiles) => {
// 	return {
// 		type: SET_DOC_CATEGORY,
// 		payload:categoriesFiles,
// 	};
// };

export const loadDocCategories = (payload) => {
	return {
		type: GET_DOC_TREE,
		payload,
	};
};

export const setDocTree = (payload) => ({
	type: SET_DOC_TREE,
	payload,
});

export const setCatmoCategories = (payload) => ({
	type: SET_CATMO_CATEGORIES,
  payload,
	
});

export const setSaraNodeId = (id) => ({
  type: SET_SARA_NODE_ID,
  payload: id
});

export const setCatmoNodeId = (id) => ({
  type: SET_CATMO_NODE_ID,
  payload: id
});

export const  deleteCatmoCategory= (categoryId) => ({
  type: DELETE_CATMO_CATEGORY,
  payload: categoryId
});

export const submitCreateCategory = (payload) => ({
	type: SUBMIT_CREATE_CATEGORY,
	payload,
  });

  export const handleCreateCategorySuccess = (payload) => ({
	type: CREATE_CATEGORY_SUCCESS,
	payload,
  });

  export const submitFile = (payload) => ({
    type: SUBMIT_FILE_REQUEST,
    payload,
  });
  export const handleFileSuccess = (payload) => ({
    type: CREATE_FILE_SUCCESS,
	  payload,
  });

  export const createFileError = (payload) => ({
	type: CREATE_FILE_ERROR,
	payload,
  });

  export const submitEditCategory = (payload) => ({
    type: SUBMIT_EDIT_CATEGORY,
    payload,
    });

    export const editCategorySuccess = (payload) => ({
      type: EDIT_CATEGORY_SUCCESS,
      payload,
    });

  export const fetchFileRequest = (payload) => ({
    type: FETCH_FILE_REQUEST,
    payload,
  });

  export const setFileData = (payload) => ({
    type: SET_FILE_DATA,  
    payload,
  });

  export const handleFetchFileSuccess = (payload) => ({
    type: FETCH_FILE_SUCCESS,
    payload,
  });

  export const submitEditFile = (payload) => ({
    type: SUBMIT_EDIT_FILE,
    payload,
    });

    export const editFileSuccess = (payload) => ({
      type: EDIT_FILE_SUCCESS,
      payload,
    });
  

  export const deleteCategory = (payload) => { 
    console.log ('delete action',payload)
    return ({
  type: DELETE_CATEGORY_REQUEST,
  payload,
  });
 }

export const deleteCategorySuccess = (payload) => ({
  type: DELETE_CATEGORY_SUCCESS,
  payload,
});

export const deleteFile = (payload) => { 
  console.log ('delete action',payload)
  return ({
type: DELETE_FILE_REQUEST,
payload,
});
}

export const deleteFileSuccess = (payload) => ({
  type: DELETE_FILE_SUCCESS,
  payload,
});
export const addUncategorizedFile = (payload) => ({
	type: ADD_UNCATEGORIZED_FILE,
	payload: payload
  });

  export const addUncategorizedFileSuccess = (payload) => ({
  type: ADD_UNCATEGORIZED_FILE_SUCCESS,
  payload
});

export const assignFileToCategory = (payload) => ({
  type: ASSIGN_FILE_TO_CATEGORY,
  payload
});

export const assignFileToCategorySuccess = (payload) => ({
  type: ASSIGN_FILE_TO_CATEGORY_SUCCESS,
  payload
});

export const assignFileToCategoryError = (errorMessage) => ({
  type: ASSIGN_FILE_TO_CATEGORY_ERROR,
  payload: errorMessage
});

//   export const processNewFile = (file) => ({
//     type: PROCESS_NEW_FILE,
//     payload: file,
// });

export const docCategoryError = (errorMessage) => ({
    type: DOC_CATEGORY_ERROR,
    payload: errorMessage,
});

export const addUncategorizedFileError = (errorMessage) => ({
    type: ADD_UNCATEGORIZED_FILE_ERROR,
    payload: errorMessage,
});

export const createCategoryError = (errorMessage) => ({
    type: CREATE_CATEGORY_ERROR,
    payload: errorMessage,
});

export const editCategoryError = (errorMessage) => ({
  type: EDIT_CATEGORY_ERROR,
  payload: errorMessage, 
});

export const editFileError = (errorMessage) => ({
  type: EDIT_FILE_ERROR,
  payload: errorMessage, 
});

export const deleteCategoryError = (errorMessage) => ({
  type: DELETE_CATEGORY_ERROR,
  payload: errorMessage,
})

export const deleteFileError = (errorMessage) => ({
  type: DELETE_FILE_ERROR,
  payload: errorMessage,
})